/**
 * ESS Planner Remote 頁面配置
 *
 * 定義所有 essPlanner 模組的頁面，自動生成：
 * - vite.config exposes
 * - remoteModules
 * - pagePermissions
 * - sideNavMenus
 */

import type { RemoteModuleConfig, PageConfig } from './types';

// ============================================================================
// 頁面配置
// ============================================================================

export const pages: PageConfig[] = [
    {
        name: 'Home',
        path: './views/Home.vue',
        title: '儲能規劃',
        mode: 'quotation',
        icon: 'icofont-battery-full',
        default: false,
        showInSideNav: true,
        standalone: { show: true, group: '主要功能', order: 1 },
    },
    {
        name: 'ProjectList',
        path: './views/ProjectList.vue',
        title: '專案列表',
        mode: 'quotation',
        icon: 'icofont-list',
        default: false,
        showInSideNav: true,
        standalone: { show: true, group: '主要功能', order: 2 },
    },
    {
        name: 'QuotationList',
        path: './views/QuotationList.vue',
        title: '報價列表',
        mode: 'quotation',
        icon: 'icofont-paper',
        default: false,
        showInSideNav: true,
        standalone: { show: true, group: '主要功能', order: 3 },
    },
    {
        name: 'CostSettings',
        path: './views/CostSettings.vue',
        title: '成本設定',
        mode: 'quotation',
        icon: 'icofont-money',
        default: false,
        showInSideNav: true,
        standalone: { show: true, group: '設定', order: 1 },
    },
    {
        name: 'RevenueAnalysis',
        path: './views/RevenueAnalysis.vue',
        title: '收益分析',
        mode: 'quotation',
        icon: 'icofont-chart-line',
        default: false,
        showInSideNav: true,
        standalone: { show: true, group: '分析', order: 1 },
    },
    {
        name: 'SheetEditor',
        path: './views/SheetEditor.vue',
        title: '表格編輯',
        mode: 'quotation',
        icon: 'icofont-table',
        default: false,
        showInSideNav: true,
        standalone: { show: true, group: '工具', order: 1 },
    },
    {
        name: 'PriceInfoParser',
        path: './views/PriceInfoParser.vue',
        title: '電價解析',
        mode: 'quotation',
        default: false,
        standalone: { show: true, group: '工具', order: 2 },
    },
    {
        name: 'SystemDiagram',
        path: './components/SystemDiagram.vue',
        title: '系統圖',
        mode: 'quotation',
        default: false,
    },
    {
        name: 'CostAnalysisPrint',
        path: './components/CostAnalysisPrint.vue',
        title: '成本分析列印',
        mode: 'quotation',
        default: false,
    },
];

// ============================================================================
// 模組完整配置
// ============================================================================

export const config: RemoteModuleConfig = {
    name: 'essPlanner',
    federationName: 'ess_planner_remote',
    port: 7004,
    pages,
};

export default config;
